import "./Banner.css";

import AboutHeading from "../../common/common_title/about_heading/AboutHeading.js";

const Banner = ({ text, redbgtext, subtext }) => {
  return (
    <section className="about_banner ">
      <div className="banner_wrapper">
        <div className="banner-img-wrapper">
          {" "}
          <img
            src="/assets/images/contact-us/banner.png"
            alt="About_Banner"
            className="img_wrapper"
          />
        </div>

        <div className="banner_content">
          <AboutHeading
            titleStart={text}
            highlight={redbgtext}
            subtitle={subtext}
          />
        </div>
      </div>
    </section>
  );
};

export default Banner;
